import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ConfirmationDialog, ConfirmationMessageComponent } from '../../comman-components/confirmation-message/confirmation-message.component';
import { MasterService } from '../master.service';
import { AddComponent } from './add/add.component';
import { debounceTime, distinctUntilChanged, map, startWith, Subscription, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';

export interface PeriodicElement {
  moduleName: string;
  prefix: string;
  sequenceNumber: number;
  suffix: string;
}
@Component({
  selector: 'app-sequence',
  templateUrl: './sequence.component.html',
  styleUrls: ['./sequence.component.scss']
})


export class SequenceComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['position', 'moduleName', 'prefix', 'startsequenceNumber','sequenceNumber',  'suffix', 'action'];
  dataSource = new MatTableDataSource<PeriodicElement>();
  constructor(private router: Router, private masterService: MasterService,
    public dialog: MatDialog, private snackBar: MatSnackBar) { }

  totalData:any;
  searchControl = new FormControl('');
  subscription: Subscription;
  isNewSequenceDisabled = false;

  ngOnInit(): void {
    // this.getSequenceData();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim();
  }

  // getSequenceData() {
  //   this.masterService.getSequenceData().subscribe(res => {
  //     this.dataSource.data = res;
  //     this.dataSource.paginator = this.paginator;
  //   })
  // }

  ngAfterViewInit() {
    
    this.dataSource.paginator = this.paginator;

    this.paginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          if(this.searchControl.value !== ''){
            return this.masterService.getSequenceDataByPageCount({ page: this.paginator.pageIndex, searchText: this.searchControl.value});  
          }
          return this.masterService.getSequenceDataByPageCount({ page: this.paginator.pageIndex });
        }),
        map((res) => {
          this.totalData = res.totalData;
          return res.data;
        })
      )
      .subscribe((data:any) => {
        this.dataSource = new MatTableDataSource(data);
      });

      this.subscription = this.searchControl.valueChanges
      .pipe(
        debounceTime(1000), // Waiting for 1 sec while you are typing
        distinctUntilChanged() // Prevents the emitting if the 'start' value and the 'end' value are the same
      )
      .subscribe(value => {
        console.log(value);
        // TODO: call BE here with this.httpClient...
        this.searchSupplier(0, value);
      });
  }

  fetchSequenceData(pageNumber: Number) {
    this.masterService.getSequenceDataByPageCount({ page: this.paginator.pageIndex }).subscribe({
      next: (res) => {
        this.dataSource.data = res?.data;
        this.totalData = res?.totalData;
        // this.dataSource.paginator = this.paginator;
      },
      error: (error) => { }
    });
  }

  searchSupplier(pageNumber: Number, search: string) {
    this.masterService.getSequenceDataByPageCount({ page: pageNumber, searchText: search }).subscribe({
      next: (res) => {
        this.dataSource.data = res?.data;
        this.totalData = res?.totalData;
        this.dataSource.paginator = this.paginator;
      },
      error: (error) => { }
    });
  }

  onAddSequence() {
    this.router.navigate(['master/sequence/add']);
  }

  public createUserDailog(userObj?) {
      if (this.isNewSequenceDisabled) {
    return;
  }

  // Disable button immediately
  this.isNewSequenceDisabled = true;

    let dialogRef = this.dialog.open(AddComponent, {
      width: '400px',
      data: userObj
    });
    dialogRef.afterClosed().subscribe(seqObj => {

       if (!seqObj) {
           this.isNewSequenceDisabled = false;
    return;
  }

  
      const payload = {
        'moduleName': seqObj.moduleName,
        'prefix': seqObj.prefix,
        'startSequence': seqObj.startSequence ?? seqObj.sequenceNumber,
        'sequenceNumber': seqObj.sequenceNumber,
        'suffix': seqObj.suffix
      };
      (seqObj.id) ? this.updateSequence(seqObj.id, payload) : this.saveSequence(payload)
    });
  }

  saveSequence(data) {
    this.masterService.addNewSequenceItem(data).subscribe(res => {
      this.snackBar.open('New Sequence added successfully!', 'Cancel', {
        duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
      });
      // this.getSequenceData();
      this.fetchSequenceData(0);
      this.isNewSequenceDisabled = false;
    },
      (error) => {
        // console.log(error.error)
        this.snackBar.open(error, 'Cancel', {
          duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
        });
        this.isNewSequenceDisabled = false;
      }
    )
  }

  updateSequence(id, data) {
    this.masterService.updateSequenceItem(id, data).subscribe(res => {
      this.snackBar.open('Updated Sequence successfully!', 'Cancel', {
        duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
      });
      // this.getSequenceData();
      this.fetchSequenceData(0);
      this.isNewSequenceDisabled = false;
    },
      (error) => {
        console.log(error.error)
        this.snackBar.open(error.errorMessage, 'Cancel', {
          duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
        });
        this.isNewSequenceDisabled = false;
      }
    )
  }

  deleteSequence(id, status) {
    let Data: ConfirmationDialog = {
      title: 'Sequence Status Confirmation',
      message: status ? 'Do you want to Deactivate Sequence?' : 'Do you want to Activate Sequence?',
      yes: 'Yes',
      no: 'No'
    }
    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      width: '400px',
      height: '200px',
      position: { top: '200px' },
      data: Data
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.masterService.deleteSequence(id).subscribe(res => {
          this.snackBar.open(`Sequence status ${status ? 'Deactivated' : 'Activated'} successfully`, 'Cancel', {
            duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
          });
          // this.getSequenceData();
          this.fetchSequenceData(0);
        },
          (error) => {
            if (error) {
              this.snackBar.open(error.message, 'Cancel', {
                duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
              });
            }
          });
      }
    });
  }

  numbersFun(index: number): number {
    return index + 1 + (this.paginator.pageIndex * this.paginator.pageSize);
  }

}
